<div id="container-filterMenuComponent">
  <div class="filters-menu menu" [ngClass]="{ 'open': isFiltersMenuOpen }">

    <div class="container-sortByToggle">
      <button type="button" [attr.aria-expanded]="isSortMenuOpen" (click)="toggleMenu('SortMenu')" name="SortMenu">
        <span>Sort Relevance</span>

        <svg class="gr-down-open" xmlns="http://www.w3.org/2000/svg">
          <use xlink:href="./assets/img/icons.svg#gr-down-open"></use>
        </svg>
      </button>
    </div>

    <div class="container-appliedFilterToggle">
      <button type="button" [attr.aria-expanded]="isFiltersMenuOpen" (click)="toggleMenu('FiltersMenu')" name="filtersMenu">
        <span><b>Filters</b> {{numFiltersApplied}} Applied</span>

        <svg class="gr-up-open" xmlns="http://www.w3.org/2000/svg">
          <use xlink:href="./assets/img/icons.svg#gr-up-open"></use>
        </svg>
      </button>
    </div>

    <section class="container-sortByMenu">
      <h4>Sort By</h4>
      <ul class="filters">
        <li *ngFor="let option of sortOptions">
          <a (click)="pushResultsSortByFilter(option.title)" [routerLink]="[resultsUrl]" [queryParams]="option.urlOptions" [ngClass]="{ 'active': option.active }" [attr.aria-checked]="option.active" [innerHTML]="option.title"></a>
        </li>
      </ul>
    </section>


    <section class="menu-item" *ngIf="suppressSourceTypes !== true">
      <h4>Source Type</h4>
      <ul class="filters sourceTypes" *ngIf="!hasSourceFilter">
        <li *ngFor="let type of sourceTypesOptions; trackBy: trackByFn">
          <ng-template [ngIf]="type.count > 0">
            <div>
              <a (click)="pushResultsSourceTypeFilter(type.label)" [routerLink]="[resultsUrl]" [queryParams]="type.urlOptions" [ngClass]="{ 'active': type.active }" [attr.aria-checked]="type.active">
                <svg [ngClass]="type.icon" xmlns="http://www.w3.org/2000/svg">
                  <use [attr.xlink:href] = "'./assets/img/icons.svg#' + type.icon"></use>
                </svg>
                <span [innerHTML]="type.label"></span>
                <span class="badge">{{type.count}}</span>
              </a>
            </div>
          </ng-template>
        </li>
      </ul>
      <ul class="filters sourceTypes" *ngIf="hasSourceFilter">
        <li *ngFor="let source of sourceFilterButton">
          <div class="selected-filter">
            {{source.label}}
            <button type="button" title="clear filter" name="source" [attr.value]="source.value" (click)="handleClearSingleFilter($event)">
              <svg class="gr-cancel-squared" xmlns="http://www.w3.org/2000/svg">
                <use xlink:href="./assets/img/icons.svg#gr-cancel-squared"></use>
              </svg>
            </button>
          </div>
        </li>
      </ul>
      <ul class="filters sourceTypes">
        <li>
          <div class="checkbox styled-checkbox">
            <input type="checkbox" [attr.id]="'currency'" [checked]="getCurrencyFilterStatus()" (change)="handleCurrencyFilters($event)">
            <label [attr.for]="'currency'">
              Exclude older newspapers and magazines
              <svg class="gr-info-circled" role="button" aria-label="more information" tabindex="0" xmlns="http://www.w3.org/2000/svg" [matTooltip]=" iseLibrary ? 'With this box checked, newspaper and magazine articles published more than two years ago will not appear in your results.': 'With this box checked, newspaper and magazine articles published more than ten years ago will not appear in your results.' ">
                <use xlink:href="./assets/img/icons.svg#gr-info-circle"></use>
              </svg>
            </label>
          </div>
        </li>
      </ul>
    </section>

    <section class="menu-item" *ngIf="suppressLimitTo !== true">
      <div>
        <h4>Limit To</h4>
        <ul class="filters">
          <li *ngFor="let option of limitToOptions">
            <div class="checkbox styled-checkbox">
              <input type="checkbox" [attr.id]="option.value" [checked]="option.active" (change)="handleLimitFilters($event)">
              <label [attr.for]="option.value" [innerHTML]="option.label"></label>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="menu-item" *ngIf="hasLexileScoreFilter">
      <div>
        <h4>Lexile Range</h4>
        <ul class="filters lexileScore">
          <li *ngFor="let lexile of lexileFilterButton">
            <div class="selected-filter">
              {{lexile.title}}
              <button type="button" title="clear filter" name="lexile" [attr.value]="lexile.value" (click)="handleClearSingleFilter($event)">
                <svg class="gr-cancel-squared" xmlns="http://www.w3.org/2000/svg">
                  <use xlink:href="./assets/img/icons.svg#gr-cancel-squared"></use>
                </svg>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="menu-item hidden-xs">
      <h4>Publication Date</h4>

      <div *ngIf="hasPubDateFilter">
        <ul>
          <li *ngFor="let pub of pubDateFilterButton">
            <div class="selected-filter">
              {{pub.title}}
              <button type="button" title="clear filter" name="pubDate" (click)="handleClearSingleFilter($event)">
                <svg class="gr-cancel-squared" xmlns="http://www.w3.org/2000/svg">
                  <use xlink:href="./assets/img/icons.svg#gr-cancel-squared"></use>
                </svg>
              </button>
            </div>
          </li>
        </ul>
      </div>

      <ul class="filters">
        <li *ngFor="let option of pubDateOptions">
          <a (click)="pushPubDateLastFilterToGA(option.title)" [routerLink]="[resultsUrl]" [queryParams]="option.urlParams" [ngClass]="{ 'active': option.active }">{{option.title}}</a>
        </li>
        <li>
          <form>
            <fieldset>
              <legend>Custom</legend>

              <div class="container-error" role="alert" *ngIf="dateRangeError" [innerHTML]="dateRangeError"></div>

              <div class="container-date">
                <pq-datepicker
                  [(date)]="filterStatus.pubDate.pubstartdate"
                  dateFormat="MM/DD/YYYY"
                  placeholder="mm/dd/yyyy"
                  inputLabel="From"
                  inputName="pubFromDate"
                  dateType="starting"
                  [hasError]="hasFromPubDateFilterError"
                  [inputStyle]="datepickerInputClass"
                  [rangeEnd]="filterStatus.pubDate.pubenddate"
                  (onChange)="onSelectFrom($event)">
                </pq-datepicker>
              </div>

              <div class="container-date">
                <pq-datepicker
                  [(date)]="filterStatus.pubDate.pubenddate"
                  dateFormat="MM/DD/YYYY"
                  placeholder="mm/dd/yyyy"
                  inputLabel="To"
                  dateType="ending"
                  inputName="pubToDate"
                  [hasError]="hasToPubDateFilterError"
                  [inputStyle]="datepickerInputClass"
                  [rangeStart]="filterStatus.pubDate.pubstartdate"
                  (onChange)="onSelectTo($event)">
                </pq-datepicker>
              </div>

              <div class="container-actions">
                <button type="button" class="btn" [disabled]="!pubDateFilterActive" (click)="doPubDateFilter()">Apply</button>
              </div>
            </fieldset>
          </form>
        </li>
      </ul>

    </section>
  </div>
  <div class="menu-sort menu" [ngClass]="{ 'open': isSortMenuOpen }">
    <section>
      <h4>Sort By</h4>
      <ul class="filters">
        <li *ngFor="let option of sortOptions">
          <a [routerLink]="[resultsUrl]" [queryParams]="option.urlOptions" [ngClass]="{ 'active': option.active }" [attr.aria-checked]="option.active" [innerHTML]="option.title"></a>
        </li>
      </ul>
    </section>
  </div>
</div>
